/**
 * Bridges the province-name mismatch between GeoNames CA.txt (admin1name) and
 * the simplemaps Canada provinces geojson (the `name` property used as
 * regionNameProperty).
 *
 * CA.txt uses:                 the geojson / CANADA_PROVINCE_FILES use:
 *   "Quebec"                ->   "Québec"
 *   "Northwest Territory"   ->   "Northwest Territories"
 *   "Nunavut Territory"     ->   "Nunavut"
 *
 * Everything else is identical in both, so it passes through unchanged.
 *
 * Apply normalizeCaRegion() to the admin1name you get back from lookupPostcode
 * BEFORE: (a) grouping/coloring by region, and (b) looking the region up in
 * CANADA_PROVINCE_FILES to pick the FSA polygon file. That keeps a single
 * canonical name (the geojson's) on both sides of the comparison.
 *
 * Data files (CA.txt) stay untouched — if you re-download GeoNames you won't
 * lose any manual edits; the aliasing lives only here.
 */
const CA_REGION_ALIASES: Record<string, string> = {
  Quebec: 'Québec',
  'Northwest Territory': 'Northwest Territories',
  'Nunavut Territory': 'Nunavut',
};

export const normalizeCaRegion = (name: string): string => CA_REGION_ALIASES[name] ?? name;
